import React from 'react';

import * as Styles from './MobileMenu.styles';

const CloseMobileTrigger = ({ closeMenuFn }) => {
  return <Styles.CloseTrigger onClick={closeMenuFn} />;
};

const MobileMenu = ({ links, closeMenuFn }) => {
  return (
    <Styles.MobileMenu>
      <CloseMobileTrigger closeMenuFn={closeMenuFn} />
      {links.map(({ link, label, label2, sublinks }) => (
        <li key={link} style={{ textAlign: 'center' }}>
          {sublinks !== undefined ? (
            <>
              <Styles.StyledLink to={`/${link}`} onClick={closeMenuFn}>
                {label}
              </Styles.StyledLink>
              {sublinks.map(({ link, label }) => {
                return (
                  <Styles.Sublink
                    key={link}
                    to={`/${link}`}
                    onClick={closeMenuFn}>
                    {label}
                  </Styles.Sublink>
                );
              })}
            </>
          ) : (
            <Styles.StyledLink to={`/${link}`} onClick={closeMenuFn}>
              {/* {label2 !== undefined ? label + ' ' + label2 : label} */}
              {label}
            </Styles.StyledLink>
          )}
        </li>
      ))}
    </Styles.MobileMenu>
  );
};

export default MobileMenu;
